import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN

export function initSentry() {
  if (!dsn) return
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release:     import.meta.env.VITE_RELEASE || 'dev',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Failed to fetch',          // network — already toasted
    ],
    beforeSend(event) {
      // Strip user emails before sending
      if (event.user?.email) event.user.email = '<redacted>'
      return event
    },
  })
}

export const SentryErrorBoundary = Sentry.ErrorBoundary
